module.exports = __webpack_public_path__ + "img/peachblossom.c9d3248c.png";